/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Data_Meal } from '../models/Data_Meal';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DataService {
    /**
     * Retrieve a list of meals.
     * @returns Data_Meal Successfully retrieved the list of meals.
     * @throws ApiError
     */
    public static menuboardMealSuggestions({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Array<Data_Meal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/data/menuboardMealSuggestions',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                400: `Validation error.`,
            },
        });
    }
}
